import React, { useEffect, useState } from 'react';

import { InfoCard } from '@eika/card';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import type { EFakturaCreditor as Creditor } from '../../generated-types';
import useTranslation from '../../hooks/useTranslation';
import { EFakturaReservationItem } from './EFakturaReservationItem';

interface Props {
    creditors: Creditor[];
}

const EFakturaReservationList: React.FC<Props> = ({ creditors }) => {
    const translated = useTranslation();
    const [blockedCreditors, setBlockedCreditors] = useState<Creditor[]>([]);

    useEffect(() => {
        setBlockedCreditors(creditors.filter((creditor) => creditor.isBlocked));
    }, [creditors]);

    if (!blockedCreditors.length) {
        return (
            <>
                <h2>{translated.eFakturaReservation.yourReservations}</h2>
                <InfoCard skipBackground>
                    <RichIcon type={RichIconTypes.FANGER_SOMMERFUGLER} />
                    <InfoCard.TitleH2>{translated.eFakturaReservation.noBlockedCreditors}</InfoCard.TitleH2>
                </InfoCard>
            </>
        );
    }

    return (
        <>
            <h2>{translated.eFakturaReservation.yourReservations}</h2>
            {blockedCreditors.map((creditor) => (
                <EFakturaReservationItem creditor={creditor} key={creditor.creditorId.value} />
            ))}
        </>
    );
};

export default EFakturaReservationList;
